// Modules
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import omit from 'lodash/omit';
import cx from 'classnames';
import { Field } from 'redux-form';
// Components
import OMPopover from '../OMPopover/OMPopover';
// Styles
import * as styles from './OMInputField.scss';
import hidePasswordIcon from '../../../../static/icons/hide-password-icon.svg';
import revealPasswordIcon from '../../../../static/icons/reveal-password-icon.svg';

class OMInputField extends Component {
  state = {
    type: this.props.type,
    isInvalid: this.props.isInvalid,
    showMobileTooltip: false,
    showTooltip: false,
    hidePassword: false
  };

  componentDidMount() {
    if (this.props.initialValue && this.inputField) {
      this.inputField.value = this.props.initialValue;
    }
  }

  componentWillReceiveProps = ({ doValidate, isInvalid, initialValue }) => {
    if (doValidate && doValidate !== this.props.doValidate) {
      this.validate(this.inputField);
    }
    if (isInvalid !== this.props.isInvalid) {
      this.setState({
        isInvalid,
        showMobileTooltip: isInvalid
      });
    }
    if (initialValue && initialValue !== this.props.initialValue && this.props.validate && this.inputField) {
      this.inputField.value = initialValue;
      this.validate(this.inputField);
    }
  };

  componentWillUpdate(nextProps, nextState) {
    if (this.props.isInvalid !== nextState.isInvalid && this.props.isMobileTemporary) {
      this.props.validationMark(nextState.isInvalid);
    }
  }

  setInputRef = (inputField) => { this.inputField = inputField; }

  validate = (target) => {
    const isValid = this.props.validate(target.value);
    if (!isValid) {
      target.classList.add('not_valid');
    } else {
      target.classList.remove('not_valid');
    }
    this.setState({
      isInvalid: !isValid,
      showMobileTooltip: !isValid
    });
  };

  handleMouseEnter = () => {
    const { isInvalid } = this.state;

    if (isInvalid) {
      this.setState({ showTooltip: true });
    }
  };

  handleMouseLeave = () => {
    if (this.state.showTooltip) {
      this.setState({ showTooltip: false });
    }
  };

  handleBlur = (event) => {
    if (this.props.fieldIsDirty) {
      this.props.fieldIsDirty(true);
    }
    if (this.props.onBlur) {
      this.props.onBlur(event);
    }
    if (this.props.validate && this.startBlurValidation(this.props.isValidIfEmpty, event.target.value)) {
      this.validate(event.target);
    }
    if (this.props.isInvalid) {
      event.target.classList.add('not_valid');
      this.setState({
        isInvalid: true,
        showMobileTooltip: true,
        showTooltip: true
      });
    }
  };

  startBlurValidation = (isValidIfEmpty, value) => (isValidIfEmpty ? !!value : true);

  handleFocus = (event) => {
    event.target.classList.remove('not_valid');
    this.setState({
      isInvalid: false,
      showMobileTooltip: false,
      showTooltip: false
    });
    if (this.props.onFocus) {
      this.props.onFocus(event);
    }
  };

  handleChange = (evt) => this.props.onChange && this.props.onChange(evt);

  handleIconClick = (event) => {
    event.preventDefault();
    this.setState({
      showMobileTooltip: !this.state.showMobileTooltip
    });
  };

  renderTooltip = () => {
    const { tooltipMessage, showHoverTooltip, isRtl } = this.props;
    return (showHoverTooltip && this.state.isInvalid) && (
      <OMPopover tooltipFor={this.inputField} isRtl={isRtl}>
        {tooltipMessage}
      </OMPopover>
    );
  };

  renderInput = (data) => {
    const { input, placeholder, type, meta: { touched, error, active } } = data;
    const InputTag = this.props.type === 'textarea' ? 'textarea' : 'input';

    return (
      <span>
        <InputTag
          {...data}
          {...input}
          className={cx({ 'has-error': error && !active && touched, touched }, 'form-control')}
          placeholder={placeholder}
          type={type}
          autoComplete={this.props.autoComplete}
          ref={this.setInputRef}
        />
        {touched &&
        (error && <span className={styles.required}>{this.props.translate('errorFieldMessages', error)}</span>)}
      </span>
    );
  };

  render() {
    const InputTag = this.props.type === 'textarea' ? 'textarea' : 'input';
    const {
      tooltipMessage, showHoverTooltip, isInvalid,
      isMobile, isRtl, hidePasswordTitle, revealPasswordTitle,
      validate, fieldIsDirty, doValidate, isValidIfEmpty, showErrorMessageDesktop,
      isForm,
      ...inputProps
    } = this.props;
    const { name, type, placeholder, title, className } = this.props;
    const inputType = (this.state.hidePassword) ? 'text' : 'password';
    const isPassword = type === 'password';

    const passwordIcon = (isPassword) && (
      <div className={styles.iconWrapper}>
        <img
          className={styles.hidePassword}
          src={(this.state.hidePassword) ? hidePasswordIcon : revealPasswordIcon}
          onClick={() => this.setState({ hidePassword: !this.state.hidePassword })}
          alt={(this.state.hidePassword) ? hidePasswordTitle : revealPasswordTitle}
          title={(this.state.hidePassword) ? hidePasswordTitle : revealPasswordTitle}
        />
      </div>
    );

    return (isMobile) ? (
      <div className={styles.mobileInput}>
        {isForm ? (
          <Field
            name={name}
            component={this.renderInput}
            isRtl={isRtl}
            {...omit(inputProps, 'initialValue')}
            onBlur={this.handleBlur}
            onFocus={this.handleFocus}
            onChange={this.handleChange}
            type={(this.state.type === 'password') ? inputType : type}
            placeholder={placeholder}
            title={title}
            className={cx('form-control', styles.inputField, className, { not_valid: isInvalid })}
            disabled={this.props.disabled}
          />
        ) : (
          <InputTag
            ref={this.setInputRef}
            {...omit(inputProps, 'initialValue')}
            onBlur={this.handleBlur}
            onFocus={this.handleFocus}
            onChange={this.handleChange}
            name={name}
            type={(this.state.type === 'password') ? inputType : type}
            placeholder={placeholder}
            title={title}
            className={cx('form-control', styles.inputField, className, { not_valid: isInvalid })}
            disabled={this.props.disabled}
            autoComplete={this.props.autoComplete}
          />
        )}
        { passwordIcon }

        { (this.state.showMobileTooltip && this.state.isInvalid) && (
          <div className={cx(styles.errorMessage, { [styles.passwordInput]: isPassword })}>
            {tooltipMessage}
          </div>
        ) }
      </div>
    ) : (
      <div
        className={cx(styles.wrapper, { [styles.contactUsInput]: this.props.className === 'contactUsForm' })}
        onMouseEnter={this.handleMouseEnter}
        onMouseLeave={this.handleMouseLeave}
      >
        {isForm ? (
          <Field
            name={name}
            component={this.renderInput}
            isRtl={isRtl}
            {...omit(inputProps, 'initialValue')}
            onBlur={this.handleBlur}
            onFocus={this.handleFocus}
            onChange={this.handleChange}
            type={(this.state.type === 'password') ? inputType : type}
            placeholder={placeholder}
            title={title}
            className={cx('form-control', styles.inputField, className, { not_valid: isInvalid })}
          />
        ) : (
          <InputTag
            {...omit(inputProps, 'initialValue')}
            ref={this.setInputRef}
            onBlur={this.handleBlur}
            onFocus={this.handleFocus}
            onChange={this.handleChange}
            name={name}
            type={(this.state.type === 'password') ? inputType : type}
            placeholder={placeholder}
            title={title}
            autoComplete={this.props.autoComplete}
            className={cx('form-control', styles.inputField, className, { not_valid: isInvalid })}
          />
        )}
        {this.state.showTooltip && this.renderTooltip()}
        { (showErrorMessageDesktop && this.state.isInvalid) && (
          <div className={cx(styles.errorMessage, { [styles.passwordInput]: isPassword })}>
            {tooltipMessage}
          </div>
        ) }
        { passwordIcon }
      </div>
    );
  }
}

OMInputField.propTypes = {
  isMobile: PropTypes.bool,
  title: PropTypes.string,
  placeholder: PropTypes.string,
  name: PropTypes.string,
  initialValue: PropTypes.string,
  type: PropTypes.string,
  className: PropTypes.string,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  validate: PropTypes.func,
  isInvalid: PropTypes.bool,
  showHoverTooltip: PropTypes.bool,
  tooltipMessage: PropTypes.string,
  fieldIsDirty: PropTypes.func,
  doValidate: PropTypes.bool,
  isValidIfEmpty: PropTypes.bool,
  hidePasswordTitle: PropTypes.string,
  revealPasswordTitle: PropTypes.string,
  isRtl: PropTypes.bool,
  isMobileTemporary: PropTypes.bool,
  validationMark: PropTypes.func,
  translate: PropTypes.func,
  disabled: PropTypes.bool,
  showErrorMessageDesktop: PropTypes.bool,
  isForm: PropTypes.bool,
  autoComplete: PropTypes.string
};

OMInputField.defaultProps = {
  disabled: false
};

export default OMInputField;
